class ToCpf {
  handle(value: string) {
    let strValue = String(value).replace(/\D/g, '').slice(0, 11)

    if (strValue.length <= 6) {
      strValue = strValue.replace(/^(\d{3})(\d)/, '$1.$2')
    } else if (strValue.length <= 9) {
      strValue = strValue.replace(/^(\d{3})(\d{3})(\d)/, '$1.$2.$3')
    } else {
      strValue = strValue.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, '$1.$2.$3-$4')
    }

    return strValue
  }
}

class ToCnpj {
  handle(value: string) {
    let strValue = String(value).replace(/\D/g, '').slice(0, 14)

    if (strValue.length <= 5) {
      strValue = strValue.replace(/^(\d{2})(\d)/, '$1.$2')
    } else if (strValue.length <= 8) {
      strValue = strValue.replace(/^(\d{2})(\d{3})(\d)/, '$1.$2.$3')
    } else if (strValue.length <= 12) {
      strValue = strValue.replace(/^(\d{2})(\d{3})(\d{3})(\d)/, '$1.$2.$3/$4')
    } else {
      strValue = strValue.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d)/,
        '$1.$2.$3/$4-$5',
      )
    }

    return strValue
  }
}

class ToCpfCnpj {
  handle(value: string) {
    let strValue = String(value).replace(/\D/g, '').slice(0, 14)

    if (strValue.length === 11) {
      strValue = strValue.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, '$1.$2.$3-$4')
    } else if (strValue.length === 14) {
      strValue = strValue.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d)/,
        '$1.$2.$3/$4-$5',
      )
    }

    return strValue
  }
}

class ToCep {
  handle(value: string) {
    let strValue = String(value).replace(/\D/g, '').slice(0, 8)

    strValue = strValue.replace(/^(\d{5})(\d)/, '$1-$2')

    return strValue
  }
}

class ToTelefone {
  handle(value: string) {
    let strValue = String(value).replace(/\D/g, '').slice(0, 11)

    if (strValue.length <= 6) {
      strValue = strValue.replace(/^(\d{2})(\d{1,4})/, '($1) $2')
    } else if (strValue.length <= 10) {
      strValue = strValue.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
    } else {
      strValue = strValue.replace(
        /^(\d{2})(\d{1})(\d{4})(\d{4})/,
        '($1) $2 $3-$4',
      )
    }

    return strValue
  }
}

class ToCurrency {
  handle(strValue: string | number | undefined) {
    let value = 0
    if (typeof strValue === 'string') {
      value = Number(String(strValue).replace(/\D/g, '')) / 100
    } else {
      value = strValue ?? 0
    }

    return value
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace(/R\$\D+/, '')
  }
}

export const InputMasks = {
  ToCpf: new ToCpf().handle,
  ToCnpj: new ToCnpj().handle,
  ToCpfCnpj: new ToCpfCnpj().handle,
  ToCep: new ToCep().handle,
  ToTelefone: new ToTelefone().handle,
  ToCurrency: new ToCurrency().handle,
}
